import {Injectable} from '@angular/core';
import {Columns, Img, PdfMakeWrapper, Table, Txt} from 'pdfmake-wrapper';
import {getFormTitle, getTcoKeyMapping, getValue, UnitlessMappingValue} from '../../models/mappingUtils';
import {error} from 'protractor';
import Tco from '../../models/tco';

@Injectable({
  providedIn: 'root'
})
export class PdfService {

  constructor() {
  }

  async generatePdf(formsWrapper: [string, any][], tcoDoughnutCharts: HTMLCanvasElement[],
                    tcoBarCharts: HTMLCanvasElement[], annualCharts: HTMLCanvasElement[],
                    categoryCharts: HTMLCanvasElement[],
                    tcoForms: {
                      dieselTCO: { title: string, value: Tco }, electricTCO?: { title: string, value: Tco },
                      hydrogenTCO?: { title: string, value: Tco }
                    }): Promise<PdfMakeWrapper> {
    // const trucks = ['diesel', 'electric', 'hydrogen'];
    // const selectedTrucks = trucks.filter(((_, index) => selectedTrucksBooleans[index]));

    const pdf = new PdfMakeWrapper();
    pdf.pageSize('A4');
    pdf.pageMargins([40, 30]);
    pdf.styles({
      formWrapper: {
        fontSize: 16,
        lineHeight: 1.5,
      },
      dieselWrapper: {
        color: '#737373'
      },
      electricWrapper: {
        color: '#A6C34E'
      },
      hydrogenWrapper: {
        color: '#25A0B6'
      },
      assumptionsWrapper: {
        color: '#222',
      },
      normalText: {
        fontSize: 10,
        color: '#747171',
        lineHeight: 1.5
      },
      title: {
        fontSize: 20,
        lineHeight: 2,
        color: '#073763'
      },
    });
    const pageWidth = 535;

    // append inputs to pdf
    formsWrapper.forEach(formWrapper => {
      if (!formWrapper[1]) {
        return;
      }

      const titleType = ['diesel', 'electric', 'hydrogen', 'assumptions']
        .find(value => formWrapper[0].includes(value))?.concat('Wrapper');


      pdf.add(new Txt(getFormTitle(formWrapper[0])).style(['formWrapper', titleType ?? '']).end);

      Object.entries(formWrapper[1])
        .filter(([key]) => !key.includes('Switch'))
        .forEach(([key, value]) => {
          const mappedValue = getValue<typeof value>(formWrapper[0], key);
          pdf.add(new Columns([
            new Txt(`${mappedValue.label}:`).bold().end,
            `\t${mappedValue.mapValue(value)} ${mappedValue.getUnit(value)}`
          ])
            .style('normalText').end);
        });

      pdf.add('\n\n\n\n\n\n\n\n');
    });
    // convert canvas to images
    const [tcoDoughnutChartsImgs, tcoBarChartsImgs, annualChartsImgs, categoryChartsImgs] = [tcoDoughnutCharts, tcoBarCharts,
      annualCharts, categoryCharts].map(chartGroup => chartGroup.map(chart => chart.toDataURL('image/png')));

    const columnGap = 10;
    const imgWidth = (pageWidth / tcoDoughnutChartsImgs.length) - columnGap * (tcoDoughnutChartsImgs.length - 1);
    pdf.add(new Txt('Costos Totales de Propiedad').style('title').end);

    const filteredTcoEntries = Object.values(tcoForms).filter(entry => entry) as { title: string, value: Tco }[];
    const titles = filteredTcoEntries.map(({title}) => title);
    const values = filteredTcoEntries.map(({value}) => value);
    // const data = values.reduce((acc, tco) => [...acc, ], [])
    const data = Object.entries(values[0]).filter(([_, val]) => typeof val === 'number').map(([key, val]) => {
      const mapping = getTcoKeyMapping(key);
      let dataEntry = [mapping.label, mapping.mapValue(val)];
      if (tcoForms.electricTCO && this.isObjKey(key, tcoForms.electricTCO.value)) {
        dataEntry = [...dataEntry, mapping.mapValue(tcoForms.electricTCO.value[key] as number)];
      }
      if (tcoForms.hydrogenTCO && this.isObjKey(key, tcoForms.hydrogenTCO.value)) {
        dataEntry = [...dataEntry, mapping.mapValue(tcoForms.hydrogenTCO.value[key] as number)];
      }
      console.log(dataEntry);
      return dataEntry;
    }) as (string | number)[][];

    let total = ['Tco', tcoForms.dieselTCO.value.getTCO()];
    if (tcoForms.electricTCO) {
      total = [...total, tcoForms.electricTCO.value.getTCO()];
    }
    if (tcoForms.hydrogenTCO) {
      total = [...total, tcoForms.hydrogenTCO.value.getTCO()];
    }

    // const [...values] = filteredTcoEntries.map(({value}) => Object.entries(value).filter(([_, val]) => typeof val === 'number')
    //   .map(([key, val]) => {
    //     const mapping = getTcoKeyMapping(key);
    //     return [mapping, ]
    //   }) as {mapping: UnitlessMappingValue, value: number}[]);
    pdf.add(new Table(
      [['', ...titles], ...data, total]
    ).alignment('center').margin([30, 0]).end);
    pdf.add(new Columns(await Promise.all(tcoDoughnutChartsImgs.map(imgUrl => new Img(imgUrl).width(imgWidth).build())))
      .columnGap(columnGap).end);
    pdf.add('\n\n');
    pdf.add(new Columns(await Promise.all(tcoBarChartsImgs.map(imgUrl => new Img(imgUrl).width(imgWidth).build())))
      .columnGap(columnGap).end);

    pdf.add('\n\n\n\n\n\n\n\n');

    pdf.add(new Txt('Costos de Propiedad Anuales').style('title').end);
    for (const imgUrl of annualChartsImgs) {
      pdf.add(await new Img(imgUrl).width(pageWidth).build());
    }

    pdf.add('\n\n\n\n\n\n\n\n');

    pdf.add(new Txt('Costos Totales de Propiedad por Catgoría').style('title').end);
    pdf.add(new Columns(await Promise.all(categoryChartsImgs.map(imgUrl => new Img(imgUrl).width(imgWidth).build())))
      .columnGap(columnGap).end);

    // pdf.images(chartImgs.reduce((acc, value, index) => ({...acc, [`chart ${index + 1}`]: value}), {}));
    // for (const imgUrl of chartImgs) {
    //   pdf.add(await new Img(imgUrl).width(500).build());
    // }

    // const hola = await Promise.all(tcoDoughnutChartsImgs.map(imgUrl =>  new Img(imgUrl).width('100%').build()));

    return pdf;
  }

  dowloadPdf(pdf: PdfMakeWrapper): void {
    pdf.create().download('InformeTCO');
  }

  viewPdf(pdf: PdfMakeWrapper): void {
    pdf.create().open();
  }


  isObjKey<T>(key: any, obj: T): key is keyof T {
    return key in obj;
  }
}
